import bind from 'bind-decorator';
import { ROUTES } from 'global/constants';
import { LibraryContentList } from 'library/components/LibraryContentList';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { NavTabs } from 'search/components/NavTabs';
import { StandardPageLayout } from 'ui/components/StandardPageLayout';
import { WrappedMessage } from 'utils';
import messages from './displayMessages';
import { localeInfo } from 'i18n';

interface LibraryPageProps extends RouteComponentProps<{}> {}

interface LibraryPageState {
    searchParams: string[];
}

/**
 * The LibraryPage is the main view of content available in LabXchange.
 *
 * It is comprised of a LibraryContentList which provides all of the searching and filtering functionality
 * for Library Content
 */
export class LibraryPage extends React.PureComponent<LibraryPageProps, LibraryPageState> {

    constructor(props: LibraryPageProps) {
        super(props);

        this.state = {
            searchParams: [`Language:${localeInfo.key}`],
        };
    }

    public render() {
        const header = <NavTabs {...this.props} />;
        const searchParams = new URLSearchParams(this.props.location.search);
        searchParams.sort(); // stabilize to avoid false positives with changes
        return (
            <StandardPageLayout pageTitle={messages.pageTitle} headerFeature={header}
                                searchParams={this.state.searchParams}>
                <div className='library-page'>
                    <h1 className='sr-only'>
                        <WrappedMessage message={messages.pageTitle}/>
                    </h1>
                    <LibraryContentList
                        onSearchParamsChanged={this.onSearchParamsChanged}
                        searchParams={searchParams.toString()}
                        isModalView={false}
                        displayAddButton={false}
                        openCardDetailUrlsInNewTab={false}
                        isPublicContentOnly={true}
                        disableDefaultFilters={searchParams.toString() !== ''}
                    />
                </div>
            </StandardPageLayout>
        );
    }

    @bind private onSearchParamsChanged(newParams: URLSearchParams) {
        const newUrl = `${ROUTES.Library.HOME}?${newParams.toString()}`;
        this.props.history.push(newUrl);
        this.setState({searchParams: newParams.getAll('t')});
    }
}
